import { useAppDispatch, useAppSelector } from '../redux/hooks';
import {
  openImageDrawer,
  openTextDrawer,
  closeImageDrawer,
  closeTextDrawer,
} from '../redux/slices/globalAIDrawerSlice';

/**
 * Custom hook for managing global AI drawers using Redux
 * Provides clean API for opening/closing drawers with minimal Redux state
 */
export function useGlobalAIDrawers() {
  const dispatch = useAppDispatch();
  const { imageDrawer, textDrawer } = useAppSelector(state => state.drawer);

  return {
    // State
    imageDrawer,
    textDrawer,
    
    // Actions - clean API following best practices
    openImageDrawer: (prompt: string, onImageSelect: (url: string) => void) =>
      dispatch(openImageDrawer({ prompt, onImageSelect })),
      
    openTextDrawer: (
      prompt: string,
      currentContent: string,
      onTextSelect: (text: string) => void
    ) => dispatch(openTextDrawer({ prompt, currentContent, onTextSelect })),
    
    closeImageDrawer: () => dispatch(closeImageDrawer()),
    closeTextDrawer: () => dispatch(closeTextDrawer()),
  };
}
